import * as React from "react";
import { Spinner } from "baseui/spinner";
import { Block, BlockProps } from "baseui/block";

type TProps = { loading?: boolean; fullPage?: boolean } & BlockProps;

export const Placeholder: React.FC<TProps> = ({
  loading,
  children,
  fullPage = false,
  ...props
}) => {
  if (loading) {
    let fullPageProps = {};
    if (fullPage) {
      fullPageProps = {
        position: "fixed",
        padding: "0",
        margin: "0",
        top: "0",
        left: "0",
        width: "100%",
        height: "100%",
        backgroundColor: "white",
      };
    }
    return (
      <Block
        display="flex"
        justifyContent="center"
        alignContent="center"
        alignItems="center"
        {...fullPageProps}
        {...props}
      >
        <Spinner />
      </Block>
    );
  } else {
    return <>{children}</>;
  }
};
